<template>
  <div class="img_box" @click="goLineAuth">
    <img class="login_other_img" src="../../../assets/img/h5_login_icon04.png" />
  </div>
</template>
<script>
var _self;
import { myMixin } from "@/tools/mixins.js";
export default {
  name: "LoginLine",
  mixins: [myMixin],
  data() {
    return {

    };
  },
  mounted() {
    _self = this;
    let type = this.getParamsHash('type');
    let id = this.getParamsHash('uid');
    let at = this.getParamsHash('at');
    if(type==='line'&&id){
      this.confirmLogin(11,{
        "uid":id,
        "accessToken":at
      });
    }
  },
  methods: {
    goLineAuth() {
      let platform = 'bcnewpay'+this.getSuffix()
      this.gosdkAuth(1,`lineAuth.html?platform=${platform}`)
    }

  }
};
</script>
<style scoped>
.img_box {
  margin: 0 0.15rem;
}
.login_other_img {
  width: 0.76rem;
  height: 0.76rem;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginSdk/LoginSdkLine.vue